import { FunctionComponent, ReactElement } from "react";
import {
  CatalogContainer,
  CatalogHeaderBanner,
  CatalogHeaderBannerTitle,
  CatalogElementContainer,
  CatalogElementContainerBlock,
} from "./styled.components";

import "assets/css/catalogslayout/index.css";
import "assets/css/carouselslider/index.css";
import { useSelector } from "react-redux";

type CatalogsLayoutProps = {
  children?: React.ReactNode;
  bannerTitle: string;
};

const CatalogsLayout: FunctionComponent<CatalogsLayoutProps> = ({
  children,
  bannerTitle,
}) => {
  const { bannerCatalog } = useSelector((state: any) => state.theme);
  const { catalogs } = useSelector((state: any) => state.theme);

  return (
    <CatalogContainer>
      <CatalogHeaderBanner
        bgImagen={
          bannerCatalog
            ? `${process.env.PUBLIC_URL}${bannerCatalog}`
            : "/commons/layer-header-@2x.png"
        }
      >
        <CatalogHeaderBannerTitle textColor={catalogs?.textTitleColor}>
          {bannerTitle}
        </CatalogHeaderBannerTitle>
      </CatalogHeaderBanner>
      <CatalogElementContainer bg={catalogs.background}>
        <CatalogElementContainerBlock bg={catalogs.backgroundItem}>
          {children}
        </CatalogElementContainerBlock>
      </CatalogElementContainer>
    </CatalogContainer>
  );
};

export default CatalogsLayout;
